import React, { useRef } from "react";
import ReactDOM from "react-dom";

import Icons from "./MiscCompo/Icons";
import "./popbox.scss";

import serverPath from "./serverpath";

const Popbox = (props) => {
	
	const popboxRef = useRef(null);
	React.useEffect(() => {
		const popboxvar = document.getElementById("popid");
		console.log("hjhjkhkj", popboxRef, popboxvar);
		// if (popboxvar) {
			popboxvar.addEventListener("keydown", function (e) {
				console.log(e.key);
				props.closeBox();
				e.preventDefault();
				e.stopPropagation();
				// if (!popboxRef.current || !popboxRef.current.contains(e.target)) {
				// }
			});
		// }
	});

	/* popboxRef.current.addEventListener("keydown", (e) => {
		console.log('11111', e.key);
		e.stopPropagation();
		if (e.key.toLowerCase() === "escape") {
			props.closeBox(e);
		}
	}); */

	const handleKeyDown = (event) => {
		if (popboxRef.current && popboxRef.current.contains(event.target)) {
			// Handle key press logic here
		}
		console.log("Arrow key pressed within the component!");
	};

	// const { ref } = useKeyPress(handleKeyDown);
	// document.addEventListener("keydown", (e) => {
	// 	e.stopPropagation();
	// 	if (e.key.toLowerCase() === "escape") {
	// 		// console.log('11111', e.key);
	// 		props.closeBox(e);
	// 	}
	// });

	return ReactDOM.createPortal(
		// <>
		<div className="popboxbody" id="popid" onClick={(e) => props.closeBox(e)} ref={popboxRef}>
			<div className="popbox" onClick={(e) => e.stopPropagation()}>
				<div className="popbox-content">
					<div className="box-head">
						<h2>{props.popupDataObj?.title}</h2>
						<div className="close" onClick={(e) => props.closeBox(e)}>
							<Icons geticon="close" />
						</div>
					</div>
					<img src={`${serverPath.dypath}${props.popupDataObj?.image}`} alt="" />
					<p className="bold">{props.popupDataObj?.content}</p>
					<p>{props.popupDataObj?.desc}</p>
				</div>
			</div>
		</div>,
		// </>
		document.getElementById("helppopup")
	);
};

export default Popbox;
